import { Head, router } from "@inertiajs/react"
import { Button, Container, Flex, Heading, Section } from "@radix-ui/themes"
import { Plus } from "lucide-react"
import ClubsTable from "@/shared/admin/ClubsTable"
import { AdminClub } from "@/types/shared"

interface Props {
  clubs: AdminClub[]
}

export default function AdminClubsIndex({ clubs }: Props) {
  const handleRowClick = (club: AdminClub) => {
    router.get(`/clubs/${club.slug}/edit`)
  }

  const handleNewClub = () => {
    router.get("/clubs/new")
  }

  return (
    <div className="flex">
      <Head title="Clubs - Admin" />
      <div className="grow">
        <Section>
          <Container size="4">
            <Flex justify="between" align="center" mb="6">
              <Heading size="7">Clubs</Heading>
              <Button onClick={handleNewClub}>
                <Plus size={18} />
                New Club
              </Button>
            </Flex>
            <ClubsTable clubs={clubs} onRowClick={handleRowClick} />
          </Container>
        </Section>
      </div>
    </div>
  )
}
